import React, { memo } from "react"

import { useConfigContext } from "@app/providers/config"
import { useRoutes } from "@app/hooks/useRoutes"
import { useShopify } from "@app/hooks/useShopify"
import Link from "@app/components/Link"

import { Box, Text, Flex, Image, Collapse } from "@chakra-ui/react"

import type { CartLine } from "@shopify/hydrogen-react/storefront-api-types"

export type CartItemBundleProps = {
  lineComponents: CartLine[]
  isOpen: boolean
}

const CartItemBundle: React.FC<CartItemBundleProps> = ({ lineComponents, isOpen }) => {
  return lineComponents?.length ? (
    <Collapse in={isOpen} animateOpacity>
      <Flex mt={3} flexDir="column" gap={3}>
        {lineComponents.map((lineItem: CartLine) => {
          return <BundleItem key={lineItem.id} lineItem={lineItem} />
        })}
      </Flex>
    </Collapse>
  ) : null
}

type BundleItemProps = {
  lineItem: CartLine
}

const BundleItem: React.FC<BundleItemProps> = ({ lineItem }) => {
  const {
    settings: { routes },
  } = useConfigContext()
  const { urlResolver } = useRoutes()
  const { imageNormaliser } = useShopify()

  const title = lineItem.merchandise.product.title
  const variant = lineItem.merchandise
  const image = imageNormaliser(lineItem.merchandise.image, "300")

  return (
    <Flex
      as={Link}
      to={urlResolver(lineItem.merchandise.product, routes.PRODUCT)?.url}
      justifyContent="space-between"
      alignContent="flex-start"
      _hover={{ textDecoration: "none" }}
      flexDir={{ base: "column", sm: "row" }}
      gap={1}
    >
      <Flex alignItems="center" justifyContent="flex-start">
        {image && (
          <Flex w="112px" flexShrink={0} justifyContent="flex-end">
            <Image src={image?.src} objectFit="cover" boxSize="100%" objectPosition="center" maxWidth="64px" />
          </Flex>
        )}
        <Box pl={4}>
          <Text size="md" color="primary.midGrey">
            1x {title}
          </Text>
          {variant.title && (
            <Text size="md" color="grey.dark">
              {variant.title}
            </Text>
          )}
        </Box>
      </Flex>
    </Flex>
  )
}

export default memo(CartItemBundle)
